import React from 'react';

import { SVGComponentProps } from './svg.types';

const MoveTaskSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M8.16667 8.16667V3.85703L6.64298 5.38071L5.46447 4.2022L9 0.666672L12.5355 4.2022L11.357 5.38071L9.83334 3.85703V8.16667H14.143L12.6193 6.64298L13.7978 5.46447L17.3333 9L13.7978 12.5355L12.6193 11.357L14.143 9.83334H9.83334V14.143L11.357 12.6193L12.5355 13.7978L9 17.3333L5.46447 13.7978L6.64298 12.6193L8.16667 14.143V9.83334H3.85703L5.38071 11.357L4.2022 12.5355L0.666672 9L4.2022 5.46447L5.38071 6.64298L3.85703 8.16667H8.16667Z"
          fill="black"
        />
      </svg>
    </span>
  );
};

export default MoveTaskSVG;
